export const CLUB = "C";
export const EQUIPO = "E";
export const PAIS = "P";
export const PROVINCIA = "R";
export const LOCALIDAD = "L";
export const SELECCION = "S";
